export default "__VITE_ASSET__DrkBGkRn__"